function TabItem({onClick, item, active}) {
    return <div
        className={`tab ${active ? 'tab--active' : ''}`}
        onClick={onClick}
    >
        {item}
    </div>
}

export default TabItem